import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const formatKeyboardShortcut = (shortcut)=>shortcut.map((key)=>{
        if ("ctrl" === key) return "\u2303";
        if ("shift" === key) return "\u21E7";
        if ("alt" === key) return "\u2325";
        if ("cmd" === key) return "\u2318";
        if ("enter" === key) return "\u21B5";
        if ("backspace" === key) return "\u232B";
        return key.toUpperCase();
    });
const useCommandKey = ()=>{
    const [isCommandPressed, setIsCommandPressed] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ("Meta" === event.key) setIsCommandPressed(true);
        };
        const handleKeyUp = (event)=>{
            if ("Meta" === event.key) setIsCommandPressed(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const handleBlur = ()=>{
            setIsCommandPressed(false);
        };
        window.addEventListener("blur", handleBlur);
        return ()=>{
            window.removeEventListener("blur", handleBlur);
        };
    }, []);
    return {
        isCommandPressed,
        setCommandPressed: setIsCommandPressed
    };
};
const useKeyPress = (targetKey)=>{
    const [isKeyPressed, setIsKeyPressed] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === targetKey) setIsKeyPressed(true);
        };
        const handleKeyUp = (event)=>{
            if (event.key === targetKey) setIsKeyPressed(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [
        targetKey
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const handleBlur = ()=>{
            setIsKeyPressed(false);
        };
        window.addEventListener("blur", handleBlur);
        return ()=>{
            window.removeEventListener("blur", handleBlur);
        };
    }, []);
    return {
        isKeyPressed,
        setKeyPressed: setIsKeyPressed
    };
};
const useHotKey = ({ hotkey: shortcutArray, action, disabled })=>{
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const shortcut = shortcutArray?.join("+").toLowerCase();
        if (disabled) return;
        if (!shortcut) return;
        if ("undefined" == typeof window) return;
        const handleKeyPress = async (event)=>{
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && ("INPUT" === activeElement.tagName || "TEXTAREA" === activeElement.tagName || activeElement.isContentEditable)) return;
            const keys = shortcut.toLowerCase().split("+").map((key)=>key.trim());
            let requiredKeys = {
                ctrl: keys.includes("ctrl"),
                shift: keys.includes("shift"),
                alt: keys.includes("alt"),
                cmd: keys.includes("cmd"),
                key: keys.find((key)=>![
                        "ctrl",
                        "shift",
                        "alt",
                        "cmd"
                    ].includes(key))
            };
            if (event.ctrlKey === requiredKeys.ctrl && event.shiftKey === requiredKeys.shift && event.altKey === requiredKeys.alt && event.metaKey === requiredKeys.cmd && event.key.toLowerCase() === requiredKeys.key) {
                event.preventDefault();
                await action();
            }
        };
        window.addEventListener("keydown", handleKeyPress);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, [
        shortcutArray,
        action
    ]);
};
const use_keyboard_shortcut = useHotKey;
export { use_keyboard_shortcut as default, formatKeyboardShortcut, useCommandKey, useHotKey, useKeyPress };
